export default {
  groups(state) {
    return state.groups;
  },
  layout(state) {
    return state.layout;
  },
  plays(state) {
    return state.plays;
  },
  capecs(state) {
    return state.capecs;
  },
  techniques(state) {
    return state.techniques;
  },
  controls(state) {
    return state.controls;
  },
  cwes(state) {
    return state.cwes;
  },
  users(state) {
    return state.users;
  },
  selectedPlay(state) {
    return state.selected.play;
  },
  selectedCAPEC(state) {
    return state.selected.capec;
  },
  selectedTechnique(state) {
    return state.selected.technique;
  },
  selectedControl(state) {
    return state.selected.control;
  },
  selectedCWE(state) {
    return state.selected.cwe;
  },
  playPagination(state) {
    return state.pagination.plays;
  },
  capecPagination(state) {
    return state.pagination.capecs;
  },
  techniquePagination(state) {
    return state.pagination.techniques;
  },
  controlPagination(state) {
    return state.pagination.controls;
  },
  cwePagination(state) {
    return state.pagination.cwes;
  },
  playOptions(state) {
    return state.formFilterOptions.plays;
  },
  capecOptions(state) {
    return state.formFilterOptions.capecs;
  },
  techniqueOptions(state) {
    return state.formFilterOptions.techniques;
  },
  spControlOptions(state) {
    // main controls only
    return state.formFilterOptions.spControls;
  },
  controlOptions(state) {
    // all controls, enhancements included
    return state.formFilterOptions.controls;
  },
  cweOptions(state) {
    return state.formFilterOptions.cwes;
  },
  tagOptions(state) {
    return state.formFilterOptions.tags;
  },
  objectiveOptions(state) {
    return state.formFilterOptions.objectives;
  },
  tacticOptions(state) {
    return state.formFilterOptions.tactics;
  },
  platformOptions(state) {
    return state.formFilterOptions.platforms;
  },
  groupOptions(state) {
    return state.formFilterOptions.groups;
  },
  familyOptions(state) {
    return state.formFilterOptions.families;
  },
  toolOptions(state) {
    return state.formFilterOptions.tools;
  },
  pendingCount(state) {
    return state.pendingApproval.count;
  },
  pendingTools(state) {
    return state.pendingApproval.tools;
  },
  pendingTags(state) {
    return state.pendingApproval.tags;
  },
  pendingObjectives(state) {
    return state.pendingApproval.objectives;
  },
  pendingPlays(state) {
    return state.pendingApproval.plays;
  },
  scenarioBuilder(state) {
    return state.scenarioBuilder;
  },
  apiLoading(state) {
    return state.apiLoading;
  },
  apiError(state) {
    return state.apiError;
  },
  authError(state) {
    return state.authError;
  },
  crudMessage(state) {
    return state.crudMessage;
  }
};
